import React, { useState } from 'react'
import { Button } from '@material-ui/core'

import { ChangeStatusSubCategoryDialog } from '../'

const ChangeStatusSubCategoryButton = ({
  subCategory,
  categoryId,
  onRefresh,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const isActive = subCategory.active !== false
  const actionText = isActive ? 'Inativar' : 'Ativar'

  const handleActionClick = (e) => {
    e.preventDefault()
    setDialogOpen(true)
  }

  return (
    <>
      <Button
        color="secondary"
        onClick={handleActionClick}
        fullWidth
        size="small"
      >
        {actionText}
      </Button>

      <ChangeStatusSubCategoryDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        subCategory={subCategory}
        categoryId={categoryId}
        onRefresh={onRefresh}
      />
    </>
  )
}

export default ChangeStatusSubCategoryButton
